import type { FC, HTMLAttributes } from "react";

import styles from "../Drawer.module.scss";

type DrawerFooterProps = HTMLAttributes<HTMLDivElement>;

export const DrawerFooter: FC<DrawerFooterProps> = ({ children, ...restProps }) => (
  <footer className={styles.drawerFooter} data-testid="drawer-footer" {...restProps}>
    {children}
  </footer>
);

DrawerFooter.displayName = "DrawerFooter";
